import {envVars} from '@/envVars.ts'
import {LOCAL_STORAGE_ACCESS_TOKEN} from '@/features/auth/constants'
import {io} from 'socket.io-client'

export const socket = io(`${envVars.VITE_WS_ENDPOINT}`, {
    transports: ['websocket'],
    auth: {
        token: localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN)
    }
})

// Function to update socket authentication and reconnect
export const updateSocketAuth = (inputToken?: string) => {
    const token = inputToken || localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN)
    socket.auth = {token}
    socket.disconnect().connect()
}
